import React from 'react';
import { SnackbarKey, useSnackbar } from 'notistack';
import styled from 'styled-components';
import { IconButton } from '@material-ui/core';
import { CloseOutlined } from '@material-ui/icons';

interface Props {
  snackbarKey?: SnackbarKey;
}

const SnackbarCloseBtnPresenter: React.FC<Props> = ({ snackbarKey }) => {
  const { closeSnackbar } = useSnackbar();

  return (
    <SnackbarCloseBtn onClick={() => closeSnackbar(snackbarKey)}>
      <CloseOutlined fontSize="small" />
    </SnackbarCloseBtn>
  );
};

export default SnackbarCloseBtnPresenter;

const SnackbarCloseBtn = styled(IconButton)`
  width: 28px;
  height: 28px;
  color: inherit;
`;
